import React from "react"

// Catches render-time errors from lazy-loaded route components and shows the
// real error instead of failing silently (the symptom of which is "URL changes
// but page stays the same"). Without this, an exception thrown during a route's
// first render unmounts the new tree before React can paint it.
export default class RouteErrorBoundary extends React.Component {
  state = { error: null, info: null }

  isDevelopment = import.meta.env.MODE === "development"

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    this.setState({ info })
    if (this.isDevelopment) {
      console.error("[RouteErrorBoundary]", error, info)
    }
  }

  componentDidUpdate(prevProps) {
    // Reset on route change so a user can navigate away from a broken page.
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null, info: null })
    }
  }

  render() {
    if (!this.state.error) return this.props.children

    const publicMessage =
      "There was an unexpected issue loading this page. Please try again or contact support if the problem persists."

    return (
      <div style={{ margin: "10% 0", color: "#c44042", textAlign: "center" }}>
        <a href="/" style={{ display: "block", marginBottom: 20 }}>
          <img src="/images/giftboxBlueRibbon-smaller.jpg" alt="Charity Choice" style={{ maxWidth: "350px", marginBottom: "20px", textDecoration: "none" }} />
        </a>
        <h2 style={{ marginBottom: 12 }}>We are sorry, something does not seem right.</h2>
        <p style={{ marginBottom: 0, color: "#333" }}>{publicMessage}</p>
        <p style={{ margin: "20px" }}><a href="/" style={{ color: "#e7a328", textDecoration: "none" }}>Go to the CharityChoice homepage</a></p>
        <p style={{ margin: "20px" }}><a href="/Contact" style={{ color: "#c44042", textDecoration: "none" }}>Contact Support</a></p>
        {this.isDevelopment && (
          <details style={{ marginTop: 16 }}>
            <summary>Developer details</summary>
            <pre style={{ whiteSpace: "pre-wrap", color: "#666", fontSize: 12 }}>
              {String(this.state.error?.stack || this.state.error)}
              {this.state.info?.componentStack ? `\n\n${this.state.info.componentStack}` : ""}
            </pre>
          </details>
        )}
      </div>
    )
  }
}
